module.exports = __webpack_public_path__ + "img/AllDefault.2dc5ed43.svg";